/** Same haversine as legacy `assets/js/delivery.js`. */
export function haversineMeters(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371000
  const toRad = (d: number) => (d * Math.PI) / 180
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

export function formatMeters(m: number): string {
  if (m < 1000) return `${m.toFixed(0)} מ׳`
  return `${(m / 1000).toFixed(2)} ק"מ`
}

export function formatSeconds(s: number): string {
  if (s < 60) return `${s.toFixed(0)} שנ׳`
  const mm = Math.floor(s / 60)
  const r = Math.round(s % 60)
  return `${mm}:${r.toString().padStart(2, '0')} דק׳`
}

export function parseCoord(v: string): number | null {
  const n = parseFloat(v)
  return Number.isFinite(n) ? n : null
}
